import React from 'react'
import { Button } from 'pcln-design-system'
import CONFIG from 'isomorphic-config'
import analytics from '@/shared-utils/analytics'
import { LOCATION_SEARCH_TYPE } from '@/types'
import styled from 'styled-components'

const LinkButton = styled(Button)`
  text-align: left;
  font-weight: bold;
  font-size: 16px;
`

export async function getClickHandler(options: {
  onLocationSelect: (item: LOCATION_SEARCH_TYPE) => void
  city: string
  state: string
}) {
  const { city, state, onLocationSelect } = options
  const searchValue = `${city}, ${state}`
  const locationConfig = CONFIG.client.typeahead.location
  const parsedURLSuffix = locationConfig.suffix.hotels
  const url = `${locationConfig.endpoint.hotels}${searchValue}${parsedURLSuffix}`
  const fetchRes = await fetch(url)
  const jsonResult: {
    matchedRegions: LOCATION_SEARCH_TYPE[]
    searchItems: LOCATION_SEARCH_TYPE[]
  } = await fetchRes.json()
  const { matchedRegions, searchItems } = jsonResult
  const itemValues = matchedRegions?.length ? matchedRegions : searchItems

  if (itemValues?.[0]) {
    analytics.fireEvent({
      category: 'pcln_home',
      action: 'penny_chat',
      label: searchValue
    })
    onLocationSelect(itemValues[0])
  }
}
export default function CityLink(props: {
  onLocationSelect: (item: LOCATION_SEARCH_TYPE) => void
  city: string
  state: string
  index: number
}) {
  const { onLocationSelect, city, state, index } = props
  return (
    <LinkButton
      variation="link"
      color="primary.base"
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        void getClickHandler({
          city,
          state,
          onLocationSelect
        })
      }}
    >
      {city}, {state}
    </LinkButton>
  )
}
